export enum ArchiveType {
  None = 1,
  Pec2Cons = 2,
  Ftp = 3,
}
